const STORAGE_KEY = 'viewerAccessKey';
const CONFIG_KEY = 'VIEWER_ACCESS_KEY';

export function getViewerAccessKey() {
    return sessionStorage.getItem(STORAGE_KEY);
}

export function getViewerAuthHeader() {
    const key = getViewerAccessKey();
    return key ? `Basic ${key}=` : null;
}

// Recebe o array cru retornado por ServiceConfig.GetConfig(): [{ Id, Key, Value }, ...]
export function persistViewerAccessKey(configList) {
    if (Array.isArray(configList)) {
        const item = configList.find(obj => obj && obj.Key === CONFIG_KEY);
        if (item && item.Value)
            sessionStorage.setItem(STORAGE_KEY, item.Value);
    }

    return getViewerAccessKey();
}
